import WidgetQuotesPresentation from 'components/WidgetQuotes/WidgetQuotesPresentation'

export default {
  Presentation: WidgetQuotesPresentation,
}
